import styled from "styled-components";
import { H500, H700, T300 } from "../Styles";
import I18n from "i18n-js";

const HowItWorksWrapper = styled.div`
  display: flex;
  padding: 104px 120px 0 120px;
  gap: 80px;

  ${({ theme }) => theme.tablet`
    padding: 64px 24px;
    text-align: center;
  `}
`;

const HowItWroksContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 24px 0;
  flex: 2;
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HeaderTitle = styled(H700)`
  font-family: Sentient;
`;

const DirectionTitle = styled(H500)`
  font-family: Sentient;
`

const DirectionsItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ theme }) => theme.tablet`
    padding: 0 32px; 
  `}
`;

const Numbering = styled.div`
  border-radius: 999px;
  border: 2px solid var(--Border-Focus, #846334);
  background: rgba(132, 99, 52, 0.20);
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.tablet`
    align-self: center; 
  `}
`;

const DirectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const ImageWrapper = styled.div`
  flex: 3;
  background-position: center;
  background-size: cover;
  background-image: url(https://theguestbook.s3.us-east-1.amazonaws.com/public/hotel_landing_how_it_works.png);

  ${({ theme }) => theme.tablet`
    display: none;
  `}
`;

const HowItWorks = () => {
  const directions = [{
    title: I18n.t("views.static_pages.hotel_landing.how_it_works.section_1.title"),
    description: I18n.t("views.static_pages.hotel_landing.how_it_works.section_1.description"),
  }, {
    title: I18n.t("views.static_pages.hotel_landing.how_it_works.section_2.title"),
    description: I18n.t("views.static_pages.hotel_landing.how_it_works.section_2.description"),
  }, {
    title: I18n.t("views.static_pages.hotel_landing.how_it_works.section_3.title"),
    description: I18n.t("views.static_pages.hotel_landing.how_it_works.section_3.description"),
  }]
  return (
    <HowItWorksWrapper>
      <HowItWroksContent>
        <HeaderWrapper>
          <T300 isStrong={true}>
            The Guestbook
          </T300>
          <HeaderTitle>
            {I18n.t("views.static_pages.hotel_landing.how_it_works.header")} 
          </HeaderTitle>
        </HeaderWrapper>
        {directions.map((item, idx) => (
          <DirectionsItem key={idx}>
            <Numbering>{idx + 1}</Numbering>
            <DirectionContent>
              <DirectionTitle>{item.title}</DirectionTitle>
              <T300>
                {item.description}
              </T300>
            </DirectionContent>
          </DirectionsItem>
        ))}
      </HowItWroksContent>
      <ImageWrapper></ImageWrapper>
    </HowItWorksWrapper>
  )
}

export default HowItWorks;